"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFormula = void 0;
const jsonpath_1 = __importDefault(require("jsonpath"));
function getFormula(data) {
    return {
        value: jsonpath_1.default.query(data, '$.Section[?(@.TOCHeading==="Names and Identifiers")]' +
            '.Section[?(@.TOCHeading==="Molecular Formula")]' +
            '.Information[0]')[0].Value.StringWithMarkup[0].String,
        label: 'Molecular Formula',
        description: jsonpath_1.default.query(data, '$.Section[?(@.TOCHeading==="Names and Identifiers")]' +
            '.Section[?(@.TOCHeading==="Molecular Formula")]')[0].Description,
    };
}
exports.getFormula = getFormula;
//# sourceMappingURL=getFormula.js.map